(ns minorodata.connections.sources.linkedin-marketing
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [applied-science.js-interop :as js-interop]
            ["date-fns" :refer [add]]
            [mold-forms.core :as form-component]))



(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::bearer-token
  (spec/and (st/spec map? {:reason "Please provide a valid auth token"})))


(spec/def ::linkedin-marketing-form
  (spec/and
    (spec/keys :req-un [::name ::bearer-token]
               :opt-un [::description])))


(def source
  {:id           "linkedin-marketing"
   :enabled      false
   :name         "LinkedIn Marketing Solutions"
   :description  "Target & reach over 690M professionals around the world using LinkedIn for your business marketing needs"
   :image-source "linkedin-marketing-solutions.png"
   :tags         ["marketing"]

   :preview-formatter
   (fn [source]
     (let [expires-at (get-in source [:credentials :bearer-token :expires-at])]
       (if (app.utils/date-expired? expires-at)
         [:span {:class "text-kleene-error-01"
                 :title         "TOKEN EXPIRED"}
          "TOKEN EXPIRED"]
         (str "Authenticated by token"))))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [bearer-token name description]} data]
        {:source-type "linkedin-marketing"
         :name        name
         :description description

         :source
         {:credentials {:bearer-token bearer-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:bearer-token]))))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (partial form-component/validate-form ::linkedin-marketing-form)

    :id :linked-marketing-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :oauth
              :label      "LinkedIn Login"
              :name       :bearer-token
              :required   true

              :request-uri      "https://www.linkedin.com/oauth/v2/authorization"
              :params-processor (fn [{:keys [client-id redirect-uri state scope response-type]}]
                                  {:response_type response-type
                                   :scope         scope
                                   :client_id     client-id
                                   :redirect_uri  redirect-uri
                                   :state         state})

              :response-processor (fn [resp]
                                    (let [expires-in (:expires-in resp)
                                          now        (js/Date.)
                                          expires-at (add now #js {:seconds expires-in})]
                                      (assoc resp :expires-at expires-at)))

              :oauth-connector-type "linkedin-marketing"
              :has-third-leg true

              :response-type "code"
              :client-id     "77ohs3xq4x4gfq"
              :scope         "r_ads r_ads_reporting"
              :redirect-uri  (str (js-interop/get-in js/window [:location :origin]) "/callback.html")}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :report            report
                    :destination-table destination-table}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :linkedin-marketing-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Ad Analytics" :value "ad-analytics"}
                           {:name "Campaigns"    :value "campaigns"}
                           {:name "Creatives"    :value "creatives"}]
              :required   true
              :value      "ad-analytics"}


             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
